import { useEffect, useState } from 'react';

/** A little longer than the drawer's own slide (antd's is 0.3 s), so the panel is never removed
 * mid-slide. Once the drawer is out of sight, holding on a moment longer shows nothing. */
export const PANEL_EXIT_MS = 400;

/**
 * True while `open` is true, and for `holdMs` after it turns false. The side panel uses it to stay
 * on the page, and to keep its contents as they were, while its drawer slides out: the moment it
 * is closed, the things that follow `open` (the node it shows, the screen it is on) would
 * otherwise change or disappear in front of the author.
 */
export function useHoldWhileClosing(
  open: boolean,
  holdMs: number = PANEL_EXIT_MS
): boolean {
  const [held, setHeld] = useState(open);
  useEffect(() => {
    if (open) {
      setHeld(true);
      return undefined;
    }
    const timer = setTimeout(() => setHeld(false), holdMs);
    return () => clearTimeout(timer);
  }, [open, holdMs]);
  // `open ||` so that opening is seen at once, without waiting for the effect.
  return open || held;
}
